import { __spreadArrays } from "tslib";
var EventBroker = /** @class */ (function () {
    function EventBroker(emitter, eventName) {
        this._emitter = emitter;
        this._eventName = eventName;
    }
    EventBroker.prototype.getEmitter = function () {
        return this._emitter;
    };
    EventBroker.prototype.register = function (cb) {
        this._emitter.on(this._eventName, cb);
    };
    EventBroker.prototype.registerOnce = function (cb) {
        this._emitter.once(this._eventName, cb);
    };
    EventBroker.prototype.unRegister = function (cb) {
        this._emitter.removeListener(this._eventName, cb);
    };
    EventBroker.prototype.registerEnsureOnce = function (cb) {
        this.unRegister(cb);
        this.register(cb);
    };
    EventBroker.prototype.emit = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this._emitter).emit.apply(_a, __spreadArrays([this._eventName], args));
    };
    return EventBroker;
}());
export { EventBroker };
//# sourceMappingURL=EventBroker.js.map